import { Link, PrintIcon } from '@dreryk/react-components';

import { printMedicalLeaveZla } from '../historicalLeaves.utils';

import { ForeignInsuredPrintModalOpener } from './ForeignInsuredPrintModal/ForeignInsuredPrintModal.opener';

type HistoricalLeavePrintActionProps = {
   readonly copyId: number;
   readonly originalId?: number;
};

const HistoricalLeavePrintAction = (props: HistoricalLeavePrintActionProps): JSX.Element => {
   if (props.originalId !== undefined) {
      return (
         <ForeignInsuredPrintModalOpener copyId={props.copyId} originalId={props.originalId}>
            {({ openModal }) => (
               <Link testId={'printForeignInsuredMedicalLeaveZla'} onClick={openModal} icon={<PrintIcon />} />
            )}
         </ForeignInsuredPrintModalOpener>
      );
   }

   const handlePrint = async (): Promise<void> => {
      await printMedicalLeaveZla(props.copyId);
   };

   return <Link testId={'printMedicalLeaveZla'} onClick={handlePrint} icon={<PrintIcon />} />;
};

export { HistoricalLeavePrintAction };
